import React from "react";
import { useTranslation } from "react-i18next";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Languages, Check } from "lucide-react";
import { SUPPORTED_LOCALES } from "@/i18n";

export default function LanguageSwitcher() {
  const { i18n, t } = useTranslation();
  const current = i18n.resolvedLanguage || i18n.language || "it";

  const change = (code) => {
    i18n.changeLanguage(code);
    try {
      localStorage.setItem("ccx_locale", code);
    } catch (e) {}
  };

  const currentLocale =
    SUPPORTED_LOCALES.find((l) => l.code === current) || SUPPORTED_LOCALES[0];

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <button
          type="button"
          className="inline-flex items-center gap-1.5 px-2.5 h-9 rounded-lg border border-[#D3D7D5] hover:bg-[#F2F4F2] text-xs font-medium text-[#475569]"
          data-testid="language-switcher"
          aria-label={t("topbar.language")}
        >
          <Languages className="w-3.5 h-3.5" />
          <span className="font-mono uppercase">{currentLocale.code}</span>
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[180px]">
        <DropdownMenuLabel className="text-[10px] uppercase tracking-widest text-[#475569]">
          {t("topbar.language")}
        </DropdownMenuLabel>
        <DropdownMenuSeparator />
        {SUPPORTED_LOCALES.map((l) => (
          <DropdownMenuItem
            key={l.code}
            onSelect={() => change(l.code)}
            className="cursor-pointer flex items-center justify-between"
            data-testid={`lang-option-${l.code}`}
          >
            <span className="flex items-center gap-2">
              <span aria-hidden>{l.flag}</span>
              <span>{l.label}</span>
            </span>
            {current === l.code && <Check className="w-3.5 h-3.5 text-[#102A43]" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
